exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-[search]-search-tsx": () => import("./../../../src/pages/search/[search].tsx" /* webpackChunkName: "component---src-pages-[search]-search-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-view-anime-tsx": () => import("./../../../src/templates/ViewAnime.tsx" /* webpackChunkName: "component---src-templates-view-anime-tsx" */)
}

